const style = {
  input: {
    '& .select-wrapper': {
      width: '100%',
    },
    '& .text-input-wrapper': {
      width: '100%',
    },
  },
}

export default style
